/**
 * Launch flags.
 *
 * Local (trip_type 1) and Rental (trip_type 2) are not yet open for booking:
 * the fleets backend only has partial rate coverage for them (one cab type
 * each), so rather than charge the placeholder fares from utils/tempRates.js we
 * show a "Coming soon" state on the booking widget and never enter the funnel.
 *
 * Outstation (trip_type 3) is fully live on real backend rates and is not
 * affected by these flags.
 *
 * TO GO LIVE with Local/Rental: set the relevant flag to false AND remove the
 * tempRates injection in store/Cab/CabAction.js once fleets returns all three
 * cab types for that product.
 */
export const COMING_SOON = {
  local: true,
  rental: true,
}

export const isComingSoon = (tripType) =>
  (tripType === 1 && COMING_SOON.local) || (tripType === 2 && COMING_SOON.rental)
